import { render, staticRenderFns } from "./StyleManagerLogoBox.vue?vue&type=template&id=2f24641d&scoped=true"
import script from "./StyleManagerLogoBox.vue?vue&type=script&lang=js"
export * from "./StyleManagerLogoBox.vue?vue&type=script&lang=js"
import style0 from "./StyleManagerLogoBox.vue?vue&type=style&index=0&id=2f24641d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f24641d",
  null
  
)

export default component.exports